import React, { useState } from 'react';
import {
  Box,
  Image,
  IconButton,
  useToast,
  VStack,
  Button,
  BoxProps,
} from '@chakra-ui/react';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

import HelpIcon from '../../../../../components/icons/Help';

type Spot = {
  x: string | number;
  y: string | number;
  info: string;
  emotion: string;
  toast?: boolean;
};

interface ImageHotspotsProps extends BoxProps {
  src: string;
  spots: Spot[];
  debug?: boolean;
  showCorrect?: boolean;
}

const ImageHotspots: React.FC<ImageHotspotsProps> = ({
  spots,
  src,
  debug,
  showCorrect,
  ...props
}) => {
  const [state, setState] = useState<boolean[]>(spots.map((s) => false));

  const toast = useToast();

  console.log({ spots });

  const ret = (
    <VStack>
      <Box position="relative" {...props}>
        <Image src={src}></Image>
        {spots.map((spot, index) => {
          return (
            <Tippy
              arrow={true}
              theme="light"
              animation="scale"
              content={spot.info}
              visible={state[index] || showCorrect}
            >
              <IconButton
                colorScheme="stemiBlue"
                borderRadius="100%"
                boxShadow="1px 1px 3px #000a"
                aria-label="info button"
                position="absolute"
                top={spot.y}
                left={spot.x}
                icon={<HelpIcon />}
                onClick={() => {
                  const newState = [...state];
                  newState[index] = !newState[index];
                  setState(newState);
                  if (spot.toast) {
                    toast({
                      title: 'You did it!',
                      description: `You clicked '${spot.info}'!`,
                      status: 'success',
                      duration: 3000,
                      isClosable: true,
                    });
                  }
                }}
              />
            </Tippy>
          );
        })}
      </Box>
      {debug && (
        <Button
          colorScheme="blue"
          onClick={() => {
            const newState = [...state];
            newState.forEach((_, i) => {
              newState[i] = true;
            });
            setState(newState);
          }}
        >
          Show all
        </Button>
      )}
    </VStack>
  );

  // if (debug) {
  //   return (
  //     <VStack w="full">
  //       {ret}
  //       <Text>
  //         <pre>{JSON.stringify(state, null, 2)}</pre>
  //       </Text>
  //     </VStack>
  //   );
  // }

  return <>{ret}</>;
};

export default ImageHotspots;
